// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.style__dataStatus--AUCdp {
  display: flex;
  flex-direction: column;
}
.style__row--x7aZC {
  align-items: center;
  display: flex;
  gap: 3rem;
  justify-content: space-between;
}
.style__popoverWrapper--C2eMN {
  position: absolute;
}
.style__title--G3Xxm {
  color: #0c0d0d;
  white-space: nowrap;
}
.style__valueComplete--IMdrb {
  color: #00a751;
  background: #eaffe9;
  border-radius: 1rem;
  padding: 0.25rem 0.5rem;
  white-space: nowrap;
}
.style__valueError--iVq27 {
  color: #d72a1d;
  background-color: #fff3f0;
  border-radius: 1rem;
  padding: 0.25rem 0.5rem;
  white-space: nowrap;
}
.style__valueErrorIcon--pqqvR {
  color: #d72a1d;
}
.style__valueCompleteIcon--RZyeF {
  color: #00a751;
}
.style__valueNotStarted--LngxC, .style__valueUploading--yFeVN {
  color: #626a65;
  background-color: #f1f4f2;
  border-radius: 1rem;
  padding: 0.25rem 0.5rem;
  white-space: nowrap;
}
.style__valueInProgress--wPYHZ {
  color: #0070cc;
  background-color: #f8f9ff;
  border-radius: 1rem;
  padding: 0.25rem 0.5rem;
  white-space: nowrap;
}
.style__test--KaXtu {
  overflow: unset !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/DataStatus/style.less"],"names":[],"mappings":"AAGA;EAEI,aAAA;EACA,sBAAA;AAHJ;AAAA;EAOI,mBAAA;EACA,aAAA;EACA,SAAA;EACA,8BAAA;AAJJ;AANA;EAcI,kBAAA;AALJ;AATA;EAkBI,cAAA;EACA,mBAAA;AANJ;AAbA;EAuBI,cAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAPJ;AApBA;EA+BI,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AARJ;AA3BA;EAuCI,cAAA;AATJ;AA9BA;EA2CI,cAAA;AAVJ;AAjCA;EAgDI,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAXJ;AAzCA;EAwDI,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AAZJ;AAgBA;EACE,0BAAA;AAdF","sourcesContent":["@import '@yaak/components/src/colors';\n@import '@yaak/components/src/spacing';\n\n:local {\n  .dataStatus {\n    display: flex;\n    flex-direction: column;\n  }\n\n  .row {\n    align-items: center;\n    display: flex;\n    gap: 3rem;\n    justify-content: space-between;\n  }\n\n  .popoverWrapper {\n    position: absolute;\n  }\n\n  .title {\n    color: @color-asphalt-grey-005;\n    white-space: nowrap;\n  }\n\n  .valueComplete {\n    color: @color-green-060;\n    background: @color-green-099;\n    border-radius: @spacing-100;\n    padding: @spacing-25 @spacing-50;\n    white-space: nowrap;\n  }\n\n  .valueError {\n    color: @color-red-050;\n    background-color: @color-red-099;\n    border-radius: @spacing-100;\n    padding: @spacing-25 @spacing-50;\n    white-space: nowrap;\n  }\n\n  .valueErrorIcon {\n    color: @color-red-050;\n  }\n\n  .valueCompleteIcon {\n    color: @color-green-060;\n  }\n\n  .valueNotStarted,\n  .valueUploading {\n    color: @color-pewter-grey-040;\n    background-color: @color-pewter-grey-095;\n    border-radius: @spacing-100;\n    padding: @spacing-25 @spacing-50;\n    white-space: nowrap;\n  }\n\n  .valueInProgress {\n    color: @color-blue-050;\n    background-color: @color-blue-099;\n    border-radius: @spacing-100;\n    padding: @spacing-25 @spacing-50;\n    white-space: nowrap;\n  }\n}\n\n.test {\n  overflow: unset !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dataStatus": `style__dataStatus--AUCdp`,
	"row": `style__row--x7aZC`,
	"popoverWrapper": `style__popoverWrapper--C2eMN`,
	"title": `style__title--G3Xxm`,
	"valueComplete": `style__valueComplete--IMdrb`,
	"valueError": `style__valueError--iVq27`,
	"valueErrorIcon": `style__valueErrorIcon--pqqvR`,
	"valueCompleteIcon": `style__valueCompleteIcon--RZyeF`,
	"valueNotStarted": `style__valueNotStarted--LngxC`,
	"valueUploading": `style__valueUploading--yFeVN`,
	"valueInProgress": `style__valueInProgress--wPYHZ`,
	"test": `style__test--KaXtu`
};
export default ___CSS_LOADER_EXPORT___;
